import React, { useEffect, useState } from 'react'
import ProposalsServices from '../../../Api/AdBazar/Proposals/ProposalsServices'
import { Autocomplete, Box, Button, Chip, Collapse, FormControl, Grid, IconButton, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import Colors from '../../../Assets/Styles/Colors';
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs';
import moment from 'moment';
import { DeleteForever, Edit, FilterAltTwoTone, KeyboardArrowLeft, KeyboardArrowRight, RemoveRedEye } from '@mui/icons-material';
import { useTheme } from '@emotion/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CircleLoading } from '../../../Components/Loaders/CircleLoading';
import IndustriesServices from '../../../Api/AdBazar/Industries/IndustriesServices';
import AuthServices from '../../../Api/Auth/AuthServices';
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.module.css"
import "../../../../App.css"

const tableHead = ["Submitted By", "Role", "Applied Date", "Job Title", "Budget", "Duration", "Proposal Status", "Action"];

function DataFilter(props) {
  const {
    usersData,
    industryData,
    name,
    role,
    selectedIndustry,
    status,
    fromDate,
    toDate,
    setName,
    setRole,
    setSelectedIndustry,
    setStatus,
    setFromDate,
    setToDate,
    sortData,
  } = props;
  const [filterCollapse, setFilterCollapse] = useState(true);

  const rolesData = [
    {
      name: "Individual",
      id: 1
    },
    {
      name: "Service Provider",
      id: 2
    },
  ]

  const statusData = [
    {
      name: "Hired",
      value: true,
      id: 1
    },
    {
      name: "Pending",
      value: "false",
      id: 1
    },
  ]

  // const handleSearch = (e) => {
  //   if (e.key == "Enter") {
  //     filterData("", "", name, selectedIndustry, "", selectedNumber);
  //   }
  // }

  const filterData = () => {
    sortData("", "", "", name?.id, role, status?.value, fromDate && new Date(fromDate), toDate && new Date(toDate));
  };

  const clearData = () => {
    setName(null);
    setRole("");
    setFromDate("");
    setToDate("");
    setStatus(null)
    sortData();
  };

  return (
    <Box sx={{ bgcolor: Colors.white, p: 2, borderRadius: "12px", mt: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="body1" fontWeight="bold" color="initial">
          Filters
        </Typography>
        <IconButton
          onClick={() => setFilterCollapse(!filterCollapse)}
          color="primary"
        >
          <FilterAltTwoTone sx={{ color: Colors.primary }} />
        </IconButton>
      </Box>

      <Collapse in={filterCollapse}>
        <Grid container spacing={2} alignItems={"flex-end"}>
          {/* <Grid item md={4}>
            <FormControl fullWidth>
              <Autocomplete
                options={usersData}
                value={name}
                renderOption={(props, option) =>
                  <MenuItem {...props} key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                }
                getOptionLabel={(option) => option.name}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setName({ id: newValue?.id, name: newValue?.name })
                  } else if (newValue == null) {
                    setName(null);
                  }
                }}
                onClose={(event, reason) => {
                  if (reason) {
                    console.log("close")
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Submitted by"
                  />
                )}
              />
            </FormControl>
          </Grid> */}

          <Grid item md={4}>
            <FormControl fullWidth>
              <Autocomplete
                options={rolesData.map((item) => item.name)}
                value={role}
                onChange={(event, newValue) => {
                  if (newValue) {
                    // sortData("", "", "", "", "", newValue)
                    setRole(newValue);
                    console.log("🚀 ~ DataFilter ~ newValue:", newValue)
                  } else if (newValue == null) {
                    setRole(null);
                  }
                }}
                onClose={(event, reason) => {
                  if (reason) {
                    console.log("close")
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Role"
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item md={4}>
            <FormControl fullWidth>
              <Autocomplete
                options={statusData}
                value={status}
                renderOption={(props, option) =>
                  <MenuItem {...props} key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                }
                getOptionLabel={(option) => option.name}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setStatus({ id: newValue.id, name: newValue?.name, value: newValue?.value });
                  } else if (newValue == null) {
                    setStatus(null);
                  }
                }}
                onClose={(event, reason) => {
                  if (reason) {
                    console.log("close")
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Status"
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item md={4}>
            <DatePicker
              showIcon
              toggleCalendarOnIconClick
              selected={fromDate}
              onChange={(update) => {
                setFromDate(update);
              }}
              isClearable={true}
              placeholderText="Applied Date (From)"
              icon={
                <svg
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  height="1em"
                  width="1em"
                >
                  <path d="M4 .5a.5.5 0 00-1 0V1H2a2 2 0 00-2 2v1h16V3a2 2 0 00-2-2h-1V.5a.5.5 0 00-1 0V1H4V.5zM16 7V5H0v5h5a1 1 0 110 2H0v2a2 2 0 002 2h12a2 2 0 002-2V9h-6a1 1 0 110-2h6z" />
                </svg>
              }
            />
          </Grid>

          <Grid item md={4}>
            <DatePicker
              showIcon
              toggleCalendarOnIconClick
              selected={toDate}
              onChange={(update) => {
                setToDate(update);
              }}
              isClearable={true}
              placeholderText="Applied Date (To)"
              icon={
                <svg
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  height="1em"
                  width="1em"
                >
                  <path d="M4 .5a.5.5 0 00-1 0V1H2a2 2 0 00-2 2v1h16V3a2 2 0 00-2-2h-1V.5a.5.5 0 00-1 0V1H4V.5zM16 7V5H0v5h5a1 1 0 110 2H0v2a2 2 0 002 2h12a2 2 0 002-2V9h-6a1 1 0 110-2h6z" />
                </svg>
              }
            />
          </Grid>

          <Grid item md={8} display="flex" justifyContent="flex-end">
            <Button
              onClick={clearData}
              variant="outlined"
              sx={{
                mx: 1,
                textTransform: "capitalize",
                minWidth: "100px",
                boxShadow:
                  `0px 3px 1px -2px rgb(0 0 0 / 20%), 
                  0px 2px 2px 0px rgb(0 0 0 / 14%),
                  0px 1px 5px 0px rgb(0 0 0 / 12%)`,
              }}
            >
              Clear
            </Button>
            <Button
              onClick={filterData}
              variant="contained"
              sx={{
                textTransform: "capitalize",
                minWidth: "100px",
                boxShadow:
                  `0px 3px 1px -2px rgb(0 0 0 / 20%),
                  0px 2px 2px 0px rgb(0 0 0 / 14%),
                  0px 1px 5px 0px rgb(0 0 0 / 12%)`,
              }}
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </Collapse>
    </Box>
  );
}

function TablePaginationActions(props) {
  const theme = useTheme;

  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}

function Proposals() {
  const [loading, setLoading] = useState(false);
  const [proposals, setProposals] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState("");
  const [users, setUsers] = useState([]);
  const [name, setName] = useState(null);
  const [role, setRole] = useState("");
  const [status, setStatus] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [industries, setIndustries] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState({ id: "", name: "" });

  const navigate = useNavigate();
  const { state } = useLocation();

  const getAllProposals = async (page, rows, adId, userId, roles, status, from, to) => {
    setLoading(true)
    try {
      const result = await ProposalsServices.getAllProposals(
        page ? page : 1,
        rows ? rows : 10,
        adId ? adId : "",
        userId ? userId : "",
        roles ? roles : "",
        status ? status : "",
        from ? from : "",
        to ? to : "",
      )
      if (result.responseCode == 200) {
        setProposals(result?.data?.proposals);
        setCount(result.data.total);
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  }

  const getAllIndustries = async () => {
    try {
      let result = await IndustriesServices.getAllIndustries();
      const obj = result.data.industry.map((item) => ({
        id: item._id, name: item.name
      }));
      setIndustries(obj)
    } catch (error) {
      console.log(error);
    }
  }

  const getAllUsers = async (page, rows, name, industry, service, phone, role) => {
    try {
      let result = await AuthServices.getAllUsers(
        page ? page : 1,
        rows ? rows : 10,
        name ? name : "",
        industry ? industry : "",
        service ? service : "",
        phone ? phone : "",
        role ? role : "",
      );
      if (result.responseCode == 200) {
        const arrayOfUsers = result?.data?.users?.map((item) => ({ name: item?.name, id: item?._id }));
        setUsers([...arrayOfUsers]);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllProposals(newPage + 1, rowsPerPage, "", name, role, status?.value, fromDate, toDate)
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Math.floor(event.target.value));
    setPage(0);
    getAllProposals(page, event.target.value, "", name, role, status?.value, fromDate, toDate)
  };

  const handleNavigate = (id) => {
    navigate(`/jobs`, { state: { id: id } });
  }

  const sort = (page, rows, adId, userId, roles, status, from, to) => {
    getAllProposals(page, rows, adId, userId, roles, status, from, to);
  }

  useEffect(() => {
    if (state) {
      getAllProposals(page, rowsPerPage, state?.id);
    } else {
      getAllProposals(page, rowsPerPage);
      getAllIndustries();
      getAllUsers();
    }
  }, [])

  return (
    <Box
      sx={{
        borderRadius: "12px",
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{
          background: Colors.primaryGradient,
          p: 2,
          borderRadius: "12px",
        }}
      >
        <Grid item xs={6}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <IconButton onClick={() => navigate(-1)}>
              <KeyboardArrowLeft sx={{ color: Colors.white }} />
            </IconButton>
            <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
              Proposals
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <BreadCrumbs currentPage={["Proposals"]} />
        </Grid>
      </Grid>
      <DataFilter
        industryData={industries}
        usersData={users}
        name={name}
        role={role}
        selectedIndustry={selectedIndustry}
        status={status}
        fromDate={fromDate}
        toDate={toDate}
        setName={setName}
        setRole={setRole}
        setSelectedIndustry={setSelectedIndustry}
        setStatus={setStatus}
        setFromDate={setFromDate}
        setToDate={setToDate}
        sortData={(page, rows, adId, userId, roles, status, from, to) =>
          sort(page, rows, adId, userId, roles, status, from, to)
        }
      />
      {loading ? (
        <CircleLoading />
      ) : (
        <Box>
          <TableContainer
            component={Paper}
            sx={{
              // width: "calc(100vw - 320px)",
              "&::-webkit-scrollbar": {
                bgcolor: Colors.white,
                height: "8px",
                borderRadius: "10px",
                cursor: "pointer",
              },
              "&::-webkit-scrollbar-thumb": {
                bgcolor: Colors.primary,
                borderRadius: "10px",
                cursor: "pointer",
              },
              "&.MuiPaper-root": {
                borderRadius: "12px",
                mt: 2,
                boxShadow: 0,
              },
            }}
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow sx={{ bgcolor: Colors.lightGray, verticalAlign: "baseline" }}>
                  {tableHead.map((item, index) => (
                    // <TableCell key={index} colSpan={item == "Posted By" || item == "Job Details" ? 2 : ""} rowSpan={2}>
                    //   <Typography
                    //     sx={{
                    //       fontWeight: "bold",
                    //       textAlign: item == "Posted By" || item == "Job Details" ? "center" : item == "Actions" && "end",
                    //       width: "250px"
                    //     }}
                    //   >
                    //     {item}
                    //   </Typography>
                    //   {item == 'Posted By' && (
                    //     <Box sx={{ width: "100%" }}>
                    //       <TableCell sx={{ borderBottom: "none", borderRight: "1px solid" }}>
                    //         <Typography >
                    //           Name
                    //         </Typography>
                    //       </TableCell>
                    //       <TableCell sx={{ borderBottom: "none" }}>
                    //         <Typography >
                    //           Role
                    //         </Typography>
                    //       </TableCell>
                    //     </Box>
                    //   )}
                    //   {item == 'Job Details' && (
                    //     <TableRow sx={{ width: "150px" }}>
                    //       <TableCell sx={{ borderBottom: "none" }}>
                    //         Job
                    //       </TableCell>
                    //       <TableCell sx={{ borderBottom: "none" }}>
                    //         Category
                    //       </TableCell>
                    //     </TableRow>
                    //   )}
                    // </TableCell>
                    <TableCell key={index}>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          // textAlign: item == "Posted By" ? "center" : item == "Actions" && "end",
                          width: "130px"
                        }}
                      >
                        {item}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {proposals.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {row?.submittedBy?.name}
                    </TableCell>
                    <TableCell>
                      {row?.submittedBy?.roles}
                    </TableCell>
                    <TableCell>
                      {moment(row?.createdAt).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell
                      component={"a"}
                      sx={{
                        textDecoration: "underline",
                        cursor: "pointer",
                        color: Colors.purple
                      }}
                      onClick={() => handleNavigate(row?.adId?._id)}
                    >
                      {row?.adId?.title}
                    </TableCell>
                    <TableCell>
                      PKR {row?.budget}
                    </TableCell>
                    <TableCell>
                      {row?.jobDuration}
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={
                          row?.status == true ? "Hired" : "Pending"
                        }
                        sx={{
                          bgcolor: row?.status == true ? Colors.success + 26 : Colors.danger + 26,
                          color: row?.status == true ? Colors.success : Colors.danger,
                          height: 26,
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Box>
                        <Tooltip title="View">
                          <IconButton onClick={() => navigate(`/proposal-details/${row._id}`, { state: row })}>
                            <RemoveRedEye sx={{ color: Colors.primary }} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Table sx={{ marginTop: "12px" }}>
            <TablePagination
              sx={{
                borderBottom: "none",
                bgcolor: Colors.white,
                borderRadius: "12px",
              }}
              rowsPerPageOptions={[10, 20, 30]}
              colSpan={12}
              count={+count}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  "aria-label": "rows per page",
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Table>
        </Box>
      )}
    </Box>
  )
}

export default Proposals